import React from 'react';
import "../printInvoice/PrintBillDesk.scss";
import moment from 'moment';

function PrintDetailed({
  componentRefDetailed,
  receipt,
  patientName,
  mocPatientId,
  patientAge,
  patientGender,
  primaryConsultant,
  centerName,
  totalAdvanceAmount,
  transactionNotes,
  brandName,
  companyName
}: any) {

  const m = moment(new Date());
  const currentDate = m.format("DD MMMM, YYYY");

  //Calculate Discount Amount
  const calculateDiscountAmount = (cost: any, discountPercentage: any, discountType: any) => {
    if (!cost || !discountPercentage) return 0;
    const costAmount = parseFloat(cost);
    if (discountType === "PERCENTAGE") {
      const discountPercentageValue = parseFloat(discountPercentage) / 100;
      const discountAmount = costAmount * discountPercentageValue;
      return discountAmount.toFixed(2);
    } else if (discountType === "AMOUNT") {
      const discountAmountValue = parseFloat(discountPercentage);
      return discountAmountValue.toFixed(2);
    }
  };

  //Calculate Grand Total
  function calculateGrandTotal(totalAmount: any, discountAmount: any) {
    //Final Amount
    const grandTotal = totalAmount - discountAmount
    return grandTotal?.toFixed(2)
  }

  return (
    <div className='print-billdesks-wrapper'
      id="printIdDetail"
      ref={componentRefDetailed}
    >
      <section className='section-wrapper'>
        <div className='heading-1'>{brandName ? brandName : `Mumbai Oncocare Centre ${centerName}`}
        </div>
        <div className='heading-2'>{companyName ? companyName : "Cellcure Cancer Centre Private Limited"}</div>
      </section>

      <section className='section-2'>
        <section className='main-section-2'>
          <div className='subHeading-main'>Patient Name:&nbsp;<span className='subHeading2-main'>{patientName}</span></div>
          <div className='subHeading-main'>Patient ID: &nbsp;<span className='subHeading2-main'> {mocPatientId}</span></div>
          <div className='subHeading-main'>Age: &nbsp;<span className='subHeading2-main'>{patientAge}</span></div>
          <div className='subHeading-main'>Gender: &nbsp;<span className='subHeading2-main'>{patientGender}</span></div>
          <div className='subHeading-main'>Primary Consultant: &nbsp;<span className='subHeading2-main'>{primaryConsultant}</span></div>
        </section>
        <section className='main-section-2'>
          <div className='subHeading-main'>Receipt Date:&nbsp; <span className='subHeading2-main'>{receipt?.receiptDateTime ? moment(receipt?.receiptDateTime).format("DD-MM-YYYY") : ''}</span>	</div>
          <div className='subHeading-main'>Receipt Number:&nbsp;<span className='subHeading2-main'>{receipt?.mocReceiptId}{" "}
          </span>
          </div>
        </section>
      </section>

      {receipt?.transactions?.[0]?.paymentType === "INVOICE" && (
        <div className="Thanks-text">
          Received with Thanks, an amount of Rs{" "}
          {receipt?.totalAmountPaid?.toFixed(2)}, {receipt?.trustName ? `from ${receipt?.trustName}` : ''} towards Payment of via {receipt?.transactions?.[0]?.modeOfPayment}
        </div>
      )}

      {receipt?.transactions?.[0]?.paymentType === "ADVANCE_PAYMENT" && (
        <div className="Thanks-text">
          Received with Thanks, an amount of Rs{" "}
          {receipt?.totalAmountPaid?.toFixed(2)}, {receipt?.trustName ? `from ${receipt?.trustName}` : ''} towards Payment of Advance Receipt
        </div>
      )}

      {receipt?.transactions?.[0]?.paymentType === "SECURITY_DEPOSIT" && (
        <div className="Thanks-text">
          Received with Thanks, an amount of Rs{" "}
          {receipt?.totalAmountPaid?.toFixed(2)}, {receipt?.trustName ? `from ${receipt?.trustName}` : ''} towards Payment of Security Deposit
        </div>
      )}

      <div className="billing-payments-table" style={{ marginBottom: '20px' }}>
        <table style={{ paddingTop: '50px' }} className="styled-table-pr" id="tablePreview">
          <thead style={{ backgroundColor: "#E1E3EF" }}>
            <tr>
              <th className='subHeading'>Receipt Id</th>
              <th className='subHeading'>Mode of Payment</th>
              <th className='subHeading'>Transaction Amount</th>
              <th className='subHeading'>Transaction Date</th>
              <th className='subHeading'>Transaction Time</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className='subHeading2'>{receipt?.mocReceiptId}</td>
              <td className='subHeading2'>{receipt?.transactions?.[0]?.modeOfPayment}</td>
              <td className='subHeading2' style={{ textAlign: "left" }}>
                {receipt?.totalAmountPaid?.toFixed(2)}
              </td>
              <td className='subHeading2'>
                {moment(receipt?.receiptDateTime).format(
                  "DD-MM-YYYY"
                )}
              </td>
              <td className='subHeading2'>
                {moment(receipt?.receiptDateTime).format(
                  "h:mm:ss a"
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {receipt?.invoicesAndTransactions?.map((inv: any) => {
        if (inv?.invoiceOutput !== null) {
          return (
            <>
              <section className="styled-table-pr">
                <div className='invoice-heading-pr'>
                  <div>
                    <div className='sd-sa-sep'>
                      <div className='subHeading-pr'>Settled Date</div>
                      <div className='subHeading-pr'>Settled Amount</div>
                    </div>
                    {inv?.settledInfo && inv?.settledInfo?.length > 0 && inv?.settledInfo?.map((setl: any) => {
                      return (
                        <div className='sd-sa-sep'>
                          <div className='subHeading2-pr'>{moment(setl?.settledDate).format("DD-MM-YYYY")}</div>
                          <div className='subHeading2-pr'>{setl?.settledAmount}</div>
                        </div>
                      )
                    })}
                  </div>
                  <div>
                    {inv?.invoiceOutput?.billedDate && (
                      <div className='subHeading-pr'>Date: &nbsp;<span className='subHeading2-pr'>{moment(inv?.invoiceOutput?.billedDate).format("DD-MM-YYYY")}</span></div>
                    )}
                    <div className='subHeading-pr'>Invoice Id: &nbsp;<span className='subHeading2-pr'>{inv?.invoiceOutput?.mocInvoiceId}</span></div>
                  </div>
                </div>
                <table className="table">
                  <thead>
                    <tr>
                      <th className='subHeading'>Treatments & Products</th>
                      <th className='subHeading'>SAC No</th>
                      <th className='subHeading'>Cost</th>
                      <th className='subHeading'>Discount</th>
                      <th className='subHeading'>Qty</th>
                      <th className='subHeading'>CGST</th>
                      <th className='subHeading'>IGST</th>
                      <th className='subHeading'>SGST</th>
                      <th className='subHeading'>Total Tax</th>
                      <th className='subHeading'>Exempt</th>
                      <th className='subHeading'>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {inv?.invoiceOutput?.invoiceItems?.map((item: any) => {
                      if (item?.archive) return null;
                      const cgstTaxes = item?.taxes?.filter((tax: any) => tax?.name === "CGST");
                      const sgstTaxes = item?.taxes?.filter((tax: any) => tax?.name === "SGST");
                      const igstTaxes = item?.taxes?.filter((tax: any) => tax?.name === "IGST");

                      return (
                        <tr key={item.id}>
                          <td className='subHeading2'>{item?.treatmentAndDetails}</td>
                          <td className='subHeading2' style={{ textTransform: 'capitalize' }}>{item?.sacNumber}</td>
                          <th className='subHeading2'>{item?.cost}</th>
                          <td className='subHeading2'>{calculateDiscountAmount(item?.cost, item?.discount, item?.discountType)}</td>
                          <td className='subHeading2'>{item?.quantity}</td>
                          <td className='subHeading2'>{cgstTaxes.length > 0 ? cgstTaxes[0]?.amount : "0"}</td>
                          <td className='subHeading2'>{igstTaxes.length > 0 ? igstTaxes[0]?.amount : "0"}</td>
                          <td className='subHeading2'>{sgstTaxes.length > 0 ? sgstTaxes[0]?.amount : "0"}</td>
                          <td className='subHeading2'>{item?.totalTaxAmount}</td>
                          <td className='subHeading2' style={{ color: "red", fontWeight: '800' }}>
                            {item?.totalTaxAmount > 0 ? "Taxable" : "Exempt"}
                          </td>
                          <td className='subHeading2'>{item?.charges}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </section>

              <section className='calculation-section-pr'>
                <div className='calc-right'>
                  <div className="calc-wrapper">
                    <div className="amount-parent">
                      <div className='subHeading'>Total Amount</div>
                      <div className='subHeading2'>{inv?.invoiceOutput?.totalLineItemCost?.toFixed(2)}</div>
                      <div className='subHeading2'>INR</div>
                    </div>
                    <hr />
                    <div className="amount-parent">
                      <div className='subHeading'>Total Line Item Discount</div>
                      <div className='subHeading2'>{inv?.invoiceOutput?.totalLineItemDiscount?.toFixed(2)}</div>
                      <div className='subHeading2'>INR</div>
                    </div>
                    <hr />
                    <div className="amount-parent">
                      <div className='subHeading'>Overall Discount</div>
                      <div className='subHeading2'>{inv?.invoiceOutput?.discountAmount?.toFixed(2)}</div>
                      <div className='subHeading2'>INR</div>
                    </div>
                    <hr />
                    <div className="amount-parent">
                      <div className='subHeading'>Grand Total</div>
                      <div className='subHeading2'>{calculateGrandTotal(inv?.invoiceOutput?.totalAmount, inv?.invoiceOutput?.discountAmount)}</div>
                      <div className='subHeading2'>INR</div>
                    </div>
                    <hr />
                    <div className="amount-parent">
                      <div className='subHeading'>Amount Previously Received</div>
                      <div className='subHeading2'>{inv?.amountPreviouslyReceived?.toFixed(2)}</div>
                      <div className='subHeading2'>INR</div>
                    </div>
                    <hr />
                    <div className="amount-parent">
                      <div className='subHeading'>Amount Received</div>
                      <div className='subHeading2'>{inv?.amountReceived?.toFixed(2)}</div>
                      <div className='subHeading2'>INR</div>
                    </div>
                    <hr />
                    <div className="amount-parent" style={{ paddingBottom: '20px' }}>
                      <div className='subHeading'>Balance Remaining</div>
                      <div className='subHeading2'>{inv?.balance?.toFixed(2)}</div>
                      <div className='subHeading2'>INR</div>
                    </div>
                  </div>
                </div>
              </section>
            </>
          );
        }

        return null;
      })}

      <section className='footer-section'>
        <div className='remaining-advance'>
          Advance as of {currentDate} is {totalAdvanceAmount?.toFixed(2)} INR
        </div>
        <div>
          <span className='notes-heading'>Notes:</span>
          <div className='notes-list'>
            {transactionNotes?.modeOfPayment && (
              <div>
                <span className='notes-list-heading'>Payment: </span>{transactionNotes?.modeOfPayment}</div>
            )}

            {transactionNotes?.transactionId && (
              <div>
                <span className='notes-list-heading'>Transaction ID: </span>{transactionNotes?.transactionId}</div>
            )}

            {transactionNotes?.amount && (
              <div>
                <span className='notes-list-heading'>Transaction Amount: </span>{transactionNotes?.amount?.toFixed(2)} INR</div>
            )}

            {receipt?.trustName && (
              <div>
                <span className='notes-list-heading'>{receipt?.transactions?.[0]?.paymentType === "ADVANCE_PAYMENT" || receipt?.transactions?.[0]?.paymentType === "SECURITY_DEPOSIT" ? 'Trust Name: ' : 'Name: '}</span>{receipt?.trustName}</div>
            )}

            {transactionNotes?.bankName && (
              <div>
                <span className='notes-list-heading'>Bank Name: </span>{transactionNotes?.bankName}</div>
            )}

            {transactionNotes?.cardNumber && (
              <div>
                <span className='notes-list-heading'>Card Number: </span>{transactionNotes?.cardNumber}</div>
            )}

            {transactionNotes?.chequeNo && (
              <div>
                <span className='notes-list-heading'>Cheque Number: </span>{transactionNotes?.chequeNo}</div>
            )}

            {transactionNotes?.tpaName && (
              <div>
                <span className='notes-list-heading'>TPA Name: </span>{transactionNotes?.tpaName}</div>
            )}

            {transactionNotes?.companyName && (
              <div>
                <span className='notes-list-heading'>Company Name: </span>{transactionNotes?.companyName}</div>
            )}

            {transactionNotes?.remarks && (
              <div>
                <span className='notes-list-heading'>Remarks: </span>{transactionNotes?.remarks}</div>
            )}
          </div>
        </div>
      </section>
    </div >
  )
}

export default PrintDetailed